
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../Global/axios";
import nodeinstance from "../../nodeInstance";

const getloanAdvanceData = createAsyncThunk("api/loan-advance", async (token) => {
  try {
    const response = await nodeinstance.get("/dashboard/loanAdvance", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  } catch (e) {
    throw new Error(e.message);
  }
});

const loanAdvanceData = createSlice({
  name: "loan-advance",
  initialState: {
    data: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {}, // You can define your other regular reducers here if needed.
  extraReducers: (builder) => {
    builder
      .addCase(getloanAdvanceData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
        state.status = true
      })
      .addCase(getloanAdvanceData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getloanAdvanceData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getloanAdvanceData };
export default loanAdvanceData.reducer;
